import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { ILocalizationLanguage } from "@dert-services";

@Component({
  selector: "app-desktop-language-select",
  templateUrl: "./language-select.component.html",
  styleUrls: ["./language-select.component.scss"],
  imports: [CommonModule, FormsModule, FontAwesomeModule],
  standalone: true,
})
export class DesktopLanguageSelectComponent {
  @Input() languages: ILocalizationLanguage[] = [];
  @Input() selectedLanguage: ILocalizationLanguage;
  @Output() languageChange: EventEmitter<ILocalizationLanguage> = new EventEmitter();

  onLanguageChange(language: ILocalizationLanguage) {
    this.languageChange.emit(language);
    // Logic to change the app's language can be added here
  }
}
